import {
    EnvironmentOutlined,
    HomeOutlined,
    IdcardOutlined,
    MailOutlined,
    PercentageOutlined,
    PhoneOutlined,
    TagOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { Input, InputNumber, Select } from "antd";
import { COUNTRY_CODES } from "../../../constants/countries";
import { NATURALEZA, TIPO_OPERACION, TIPO_DOCUMENTO_FE, TIPO_CONTRIBUYENTE } from "../../../constants/electronicInvoice";
import { buildDocumentOptions, buildDocumentValidator, buildOptions } from "../../../utils/dynamicFormFieldsUtils";
import { buildSelectOptions } from "../../../services/selectOptionService";
import AsyncSelect from "../../AsyncSelect/AsyncSelect";

export const CLIENT_FORM_CONFIG = {
    [COUNTRY_CODES.ECUADOR]: {
        sections: [
            {
                title: null,
                fields: [
                    {
                        name: "name",
                        label: "Nombre",
                        component: Input,
                        prefix: <UserOutlined />,
                        rules: [{ required: true, message: "Ingrese el nombre del cliente" }],
                        props: { placeholder: "Nombre del cliente" },
                    },
                    {
                        name: "Tipo_Documento_SrI",
                        label: "Tipo Documento",
                        component: Select,
                        props: (country) => ({
                            placeholder: "Seleccione el tipo de documento",
                            options: buildDocumentOptions(country),
                        }),
                        rules: [
                            { required: true, message: "Por favor seleccione el tipo de documento" },
                        ],
                        clearFieldsOnUpdate: ["Numero_Identificacion_fiscal"],
                    },
                    {
                        name: "Numero_Identificacion_fiscal",
                        label: "Número de cédula/RUC/Pasaporte",
                        component: Input,
                        prefix: <IdcardOutlined />,
                        dynamicValidator: buildDocumentValidator,
                        validationDependency: "Tipo_Documento_SrI",
                        props: { placeholder: "Número de documento" },
                    },
                ],
            },
            {
                title: "Información de contacto",
                fields: [
                    {
                        name: "E_Mail",
                        label: "Email",
                        component: Input,
                        prefix: <MailOutlined />,
                        rules: [
                            { type: "email", message: "Formato de email inválido" },
                            { required: true, message: "Por favor ingrese un email" },
                        ],
                        props: { placeholder: "Correo electrónico" },
                    },
                    {
                        name: "Customer_Price_Group",
                        label: "Grupo de precios",
                        component: Input,
                        prefix: <TagOutlined />,
                        props: { placeholder: "Grupo de precios" },
                    },
                    {
                        name: "Telefono",
                        label: "Teléfono",
                        component: Input,
                        prefix: <PhoneOutlined />,
                        rules: [
                            { required: true, message: "Ingrese un número de teléfono" },
                            { pattern: /^\+?[0-9]+$/, message: "El teléfono solo puede contener números" },
                        ],
                        props: { placeholder: "Teléfono fijo" },
                    },
                    {
                        name: "Mobil",
                        label: "Móvil",
                        component: Input,
                        prefix: <PhoneOutlined />,
                        props: { placeholder: "Número de móvil" },
                    },
                    {
                        name: "Pais",
                        label: "País",
                        component: Input,
                        prefix: <EnvironmentOutlined />,
                        rules: [
                            { required: true, message: "Ingrese un país" }
                        ],
                        props: { placeholder: "País" },
                    },
                ],
            },
            {
                title: "Dirección",
                fields: [
                    {
                        name: "Direccion",
                        label: "Dirección",
                        component: Input,
                        prefix: <HomeOutlined />,
                        rules: [{ required: true, message: "Ingrese la dirección" }],
                        props: { placeholder: "Dirección principal" },
                    },
                    {
                        name: "Direccion_2",
                        label: "Envio a Colonia 2",
                        component: Input,
                        prefix: <HomeOutlined />,
                        props: { placeholder: "Dirección secundaria o información adicional de envío" },
                    },
                    {
                        name: "Poblacion",
                        label: "Ciudad",
                        component: Input,
                        prefix: <EnvironmentOutlined />,
                        props: { placeholder: "Ciudad" },
                    },
                ],
            },
            {
                title: "Descuento",
                fields: [
                    {
                        name: "POS_Discount",
                        label: "Descuento TPV (%)",
                        component: InputNumber,
                        prefix: <PercentageOutlined />,
                        props: {
                            min: 0,
                            max: 100,
                            precision: 2,
                            disabled: true,
                            style: { width: "100%" },
                            placeholder: "Descuento TPV"
                        },
                    },
                ],
            },
        ],
    },
    [COUNTRY_CODES.PARAGUAY]: {
        sections: [
            {
                title: null,
                fields: [
                    {
                        name: "name",
                        label: "Nombre",
                        component: Input,
                        prefix: <UserOutlined />,
                        rules: [{ required: true, message: "Ingrese el nombre del cliente" }],
                        props: { placeholder: "Nombre del cliente" },
                    },
                    {
                        name: "Tipo_Documento_SrI",
                        label: "Tipo Documento",
                        component: Select,
                        props: (country) => ({
                            placeholder: "Seleccione el tipo de documento",
                            options: buildDocumentOptions(country),
                        }),
                        rules: [
                            { required: true, message: "Seleccione el tipo de documento" },
                        ],
                        clearFieldsOnUpdate: ["Numero_Identificacion_fiscal"],
                    },
                    {
                        name: "Numero_Identificacion_fiscal",
                        label: "Número de cédula/RUC/Pasaporte",
                        component: Input,
                        prefix: <IdcardOutlined />,
                        dynamicValidator: buildDocumentValidator,
                        validationDependency: "Tipo_Documento_SrI"
                    },
                ],
            },
            {
                title: "Información de contacto",
                fields: [
                    {
                        name: "E_Mail",
                        label: "Email",
                        component: Input,
                        prefix: <MailOutlined />,
                        rules: [
                            { type: "email", message: "Formato de email inválido" },
                            { required: true, message: "Por favor ingrese un email" },
                        ],
                        props: { placeholder: "Correo electrónico" },
                    },
                    {
                        name: "Telefono",
                        label: "Teléfono",
                        component: Input,
                        prefix: <PhoneOutlined />,
                        rules: [
                            { required: true, message: "Ingrese un número de teléfono" },
                            { pattern: /^\+?[0-9]+$/, message: "El teléfono solo puede contener números" },
                        ],
                        props: { placeholder: "Teléfono fijo" },
                    },
                    {
                        name: "Mobil",
                        label: "Móvil",
                        component: Input,
                        prefix: <PhoneOutlined />,
                        rules: [
                            { required: true, message: "Ingrese un número de móvil" }
                        ],
                        props: { placeholder: "Número de móvil" },
                    },
                    {
                        name: "Pais",
                        label: "País",
                        component: Input,
                        prefix: <EnvironmentOutlined />,
                        rules: [
                            { required: true, message: "Ingrese un país" }
                        ],
                        props: { placeholder: "País" },
                    },
                ],
            },
            {
                title: "Dirección",
                fields: [
                    {
                        name: "Direccion",
                        label: "Dirección",
                        component: Input,
                        prefix: <HomeOutlined />,
                        rules: [{ required: true, message: "Ingrese la dirección" }],
                        props: { placeholder: "Dirección principal" },
                    },
                    {
                        name: "Direccion_2",
                        label: "Envio a Colonia 2",
                        component: Input,
                        prefix: <HomeOutlined />,
                        props: { placeholder: "Dirección secundaria o información adicional de envío" },
                    },
                    {
                        name: "Poblacion",
                        label: "Ciudad",
                        component: Input,
                        prefix: <EnvironmentOutlined />,
                        props: { placeholder: "Ciudad" },
                    },
                ],
            },
            {
                title: "Factura electrónica",
                fields: [
                    {
                        name: "EInvNature",
                        label: "Naturaleza",
                        component: Select,
                        props: () => ({
                            placeholder: "Seleccione naturaleza",
                            options: buildOptions(NATURALEZA),
                        }),
                        rules: [
                            { required: true, message: "Seleccione naturaleza" },
                        ],
                    },
                    {
                        name: "EInvOperationType",
                        label: "Tipo de operación",
                        component: Select,
                        props: () => ({
                            placeholder: "Seleccione tipo de operación",
                            options: buildOptions(TIPO_OPERACION),
                        }),
                        rules: [
                            { required: true, message: "Seleccione operación" },
                        ],
                    },
                    {
                        name: "EInvTaxPayerType",
                        label: "Tipo de contribuyente",
                        component: Select,
                        props: () => ({
                            placeholder: "Seleccione tipo de contribuyente",
                            options: buildOptions(TIPO_CONTRIBUYENTE),
                            allowClear: true
                        }),
                    },
                    {
                        name: "EInvDocumentTypeID",
                        label: "Tipo de documento",
                        component: Select,
                        props: () => ({
                            placeholder: "Seleccione tipo de documento",
                            options: buildOptions(TIPO_DOCUMENTO_FE),
                            allowClear: true
                        }),
                    },
                    {
                        name: "AnotherDocument",
                        label: "Otro documento",
                        component: Input,
                        props: {
                            placeholder: "Documento",
                            maxLength: 20
                        },
                    },
                    {
                        name: "EInvDocumentNoID",
                        label: "Número Doc. Id.",
                        component: Input,
                        props: {
                            placeholder: "Número de documento",
                            maxLength: 20
                        },
                    },
                    {
                        name: "EInvHouseNo",
                        label: "Número Casa",
                        component: InputNumber,
                        props: {
                            min: 0,
                            style: { width: "100%" },
                            placeholder: "Número de casa",
                        },
                    },
                    {
                        name: "EInvDepartmentCode",
                        label: "Cód. Departamento",
                        component: AsyncSelect,
                        props: {
                            placeholder: "Código departamento",
                            loadOptionsFn: () => buildSelectOptions("Departamentos"),
                            searchEnabled: true
                        },
                    },
                    {
                        name: "EInvDistrictCode",
                        label: "Cód. Distrito",
                        component: AsyncSelect,
                        props: {
                            placeholder: "Código distrito",
                            loadOptionsFn: () => buildSelectOptions("Distritos"),
                            searchEnabled: true
                        },
                    },
                    {
                        name: "EInvCityCode",
                        label: "Cód. Ciudad",
                        component: AsyncSelect,
                        props: {
                            placeholder: "Código ciudad",
                            loadOptionsFn: () => buildSelectOptions("Ciudades"),
                            searchEnabled: true
                        },
                    },
                    {
                        name: "Salesperson_Code",
                        label: "Cód. Vendedor",
                        component: AsyncSelect,
                        props: {
                            placeholder: "Código vendedor",
                            loadOptionsFn: () => buildSelectOptions("Vendedores"),
                            searchEnabled: true
                        },
                        rules: [
                            { required: true, message: "Seleccione vendedor" },
                        ],
                    },
                    {
                        name: "Invoice_Disc__Code",
                        label: "Cód. descuento facturación",
                        component: Input,
                        props: {
                            style: { width: "100%" },
                            placeholder: "Código de descuento",
                            disabled: true,
                        },
                    },
                    {
                        name: "Customer_Price_Group",
                        label: "Cód. grupo de precios",
                        component: AsyncSelect,
                        props: {
                            style: { width: "100%" },
                            placeholder: "Código de grupo de precios",
                            loadOptionsFn: () => buildSelectOptions("GrupoPrecios"),
                            searchEnabled: true,
                            disabled: true
                        },
                    },
                    {
                        name: "No",
                        label: "",
                        component: Input,
                        hidden: true,
                        props: {
                            type: "hidden",
                        },
                    },
                    {
                        name: "TPV_GroupPrice",
                        label: "",
                        component: Input,
                        hidden: true,
                        props: {
                            type: "hidden",
                        },
                    }
                ],
            },
        ],
    },
    [COUNTRY_CODES.HONDURAS]: {    //Honduras no edita ni crea clientes
        sections: [
            {
                title: null,
                fields: [
                    {
                        name: "name",
                        label: "Nombre",
                        component: Input,
                        prefix: <UserOutlined />,
                        props: { disabled: true },
                    },
                    {
                        name: "Tipo_Documento_SrI",
                        label: "Tipo Documento",
                        component: Input,
                        props: { disabled: true },
                    },
                    {
                        name: "Numero_Identificacion_fiscal",
                        label: "Número de cédula/RUC/Pasaporte",
                        component: Input,
                        prefix: <IdcardOutlined />,
                        props: { disabled: true },
                    },
                ],
            },
            {
                title: "Información de contacto",
                fields: [
                    {
                        name: "E_Mail",
                        label: "Email",
                        component: Input,
                        prefix: <MailOutlined />,
                        props: { disabled: true },
                    },
                    {
                        name: "Customer_Price_Group",
                        label: "Grupo de precios",
                        component: Input,
                        prefix: <TagOutlined />,
                        props: { disabled: true },
                    },
                    {
                        name: "Telefono",
                        label: "Teléfono",
                        component: Input,
                        prefix: <PhoneOutlined />,
                        props: { disabled: true },
                    },
                    {
                        name: "Mobil",
                        label: "Móvil",
                        component: Input,
                        prefix: <PhoneOutlined />,
                        props: { disabled: true },
                    },
                    {
                        name: "Pais",
                        label: "País",
                        component: Input,
                        prefix: <EnvironmentOutlined />,
                        props: { disabled: true },
                    },
                ],
            },
            {
                title: "Dirección",
                fields: [
                    {
                        name: "Direccion",
                        label: "Dirección",
                        component: Input,
                        prefix: <HomeOutlined />,
                        props: { disabled: true },
                    },
                    {
                        name: "Direccion_2",
                        label: "Envio a Colonia 2",
                        component: Input,
                        props: { disabled: true },
                    },
                    {
                        name: "Poblacion",
                        label: "Ciudad",
                        component: Input,
                        prefix: <EnvironmentOutlined />,
                        props: { disabled: true },
                    },
                ],
            },
        ],
    },
};

export const getClientFormConfig = (pais) => CLIENT_FORM_CONFIG[pais] || CLIENT_FORM_CONFIG[COUNTRY_CODES.ECUADOR];